import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as actConfirmAction from 'actions/confirm-action';
import styles from './style.css';

class MoveAwayModal extends React.Component {
  render() {
    const { showConfirmActionModal } = this.props;

    return (
      <Modal
        show={showConfirmActionModal}
        className={`${styles.modal}`}
        dialogClassName={`modal-dialog ${styles['modal-dialog']}`}
      >
        <Modal.Header>
          <Modal.Title>
            <span className="pull-left">Unsaved Changes</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Do you want to leave? Changes you made may not be saved.
        </Modal.Body>

        <Modal.Footer>
          <button
            className={`btn mr-10px ${styles['btn-outline-dark']} ${
              styles['btn-large']
            }`}
            type="button"
            onClick={this._onClickStay}
          >
            Stay
          </button>
          <button
            className={`btn btn-primary ${styles['btn-large']}`}
            onClick={this._onClickLeave}
          >
            Leave
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _onClickStay = () => {
    this.props.dispatch(actConfirmAction.cancelAction());
  };

  _onClickLeave = () => {
    this.props.dispatch(actConfirmAction.confirmAction(this.props.nextAction));
  };
}

function mapStateToProps(state) {
  const { nextAction, showConfirmActionModal } = state.confirmAction;

  return {
    nextAction,
    showConfirmActionModal,
  };
}

export default connect(mapStateToProps)(MoveAwayModal);
